var SidenavService = /** @class */ (function () {
    function SidenavService() {
    }
    SidenavService.prototype.setSidenav = function (sidenav) {
        this.sidenav = sidenav;
    };
    SidenavService.prototype.open = function () {
        return this.sidenav.open();
    };
    SidenavService.prototype.close = function () {
        return this.sidenav.close();
    };
    SidenavService.prototype.toggle = function () {
        this.sidenav.toggle();
    };
    return SidenavService;
}());
export { SidenavService };
